<template>
  <div class="carpin">
    <el-row>
      <el-col :span="3" class="img">
        <div class="grid-content" style="background-color: #6590ff;" @click="$message.warning('请在手机端操作完成')">
          <img :src="require('@/assets/image/default/carpin/mobile.png')">
          <span>手机录单</span>
        </div>
        <div class="grid-content" style="background-color: #ff67af;" @click="toJump('销售订单录单', '/Account/sys/salOrder/orderEntering.html', 96)">
          <img :src="require('@/assets/image/default/carpin/computer.png')">
          <span>电脑录单</span>
        </div>
      </el-col>
      <el-col :span="1" class="divider">
        <el-divider></el-divider>
        <el-divider direction="vertical"></el-divider>
        <el-divider></el-divider>
      </el-col>
      <el-col :span="3" class="divider">
        <el-divider></el-divider>
      </el-col>
      <el-col :span="3" class="img">
        <div class="grid-content" style="background-color: #ff9c65;" @click="toJump('订单管理', '/Account/sys/presellProcess/orderManagement.html', 98)">
          <img :src="require('@/assets/image/default/carpin/allocation.png')">
          <span>生成配货单</span>
        </div>
      </el-col>
      <el-col :span="9" class="divider" style="align-items: center;">
        <span>库管员见</span>
        <el-divider></el-divider>
        <span>单发货</span>
      </el-col>
      <el-col :span="1" class="divider" style="align-items: flex-start;">
        <el-divider direction="vertical" class="vertical_one"></el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" class="img">
        <div class="grid-content" style="background-color: #ffdd65;" @click="toJump('上交款结账', '/Account/sys/salCheckout/indexForVue.html', 70, [70, 333])">
          <img :src="require('@/assets/image/default/carpin/salesman.png')">
          <span>配送员结账</span>
        </div>
      </el-col>
      <el-col :span="3" class="divider">
        <el-divider></el-divider>
      </el-col>
      <el-col :span="1" class="divider" style="align-items: flex-start;">
        <el-divider></el-divider>
        <el-divider direction="vertical" class="vertical"></el-divider>
        <el-divider></el-divider>
      </el-col>
      <el-col :span="12" class="child">
        <el-row>
          <el-col :span="6" class="img">
            <div class="grid-content" style="background-color: #65b1ff;" @click="toJump('退货审核', '/Account/sys/InvReturnCheck/invReturnCheck.html', 174)">
              <img :src="require('@/assets/image/default/carpin/returnaudit.png')">
              <span>退货审核</span>
            </div>
          </el-col>
          <el-col :span="6" class="divider" style="align-items: center;">
            <span>批量打</span>
            <el-divider></el-divider>
            <span>单送货</span>
          </el-col>
          <el-col :span="6" class="img">
            <div class="grid-content" style="background-color: #7e65ff;" @click="toJump('订单管理', '/Account/sys/presellProcess/orderManagement.html', 98)">
              <img :src="require('@/assets/image/default/advance/resale.png')">
              <span>转为销售单</span>
            </div>
          </el-col>
          <el-col :span="6" class="divider" style="align-items: center;">
            <span>电脑打单</span>
            <el-divider></el-divider>
            <span>配货模式</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="img">
            <div class="grid-content" style="background-color: #ff7567;" @click="toJump('订单余货', '/Account/sys/presellProcess/orderManagement.html?activeName=accomplish', 98)">
              <img :src="require('@/assets/image/default/advance/order.png')">
              <span>订单余货</span>
            </div>
          </el-col>
          <el-col :span="4" class="divider">
            <el-divider></el-divider>
          </el-col>
          <el-col :span="2" class="divider" style="align-items: flex-start;">
            <el-divider></el-divider>
            <el-divider direction="vertical"></el-divider>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="6" class="img">
            <div class="grid-content" style="background-color: #ef67ff;" @click="toJump('拜访明细', '/Account/sys/visitAnalysisVue/index.html', 120)">
              <img :src="require('@/assets/image/default/carpin/visit.png')">
              <span>拜访明细</span>
            </div>
            <div class="grid-content" style="background-color: #6780ff;" @click="toJump('拜访轨迹', '/Account/sys/saleManTrajectoryVue/index.html', 119)">
              <img :src="require('@/assets/image/default/advance/storepin.png')">
              <span>拜访轨迹</span>
            </div>
          </el-col>
          <el-col :span="2" class="divider">
            <el-divider></el-divider>
            <el-divider direction="vertical"></el-divider>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="4" class="divider" style="align-items: center;">
            <span>手机订单</span>
            <el-divider></el-divider>
            <span>配货模式</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1" class="divider" style="align-items: flex-start;">
        <el-divider direction="vertical" class="vertical_two"></el-divider>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  mounted () {
    this.onresize()
  },
  methods: {
    onresize () {
      $('.grid-content').css({
        'height': parseInt($('.grid-content').css('width')) * 0.7 + 'px',
        'font-size': parseInt($('.grid-content').css('width')) * 0.07 + 'px'
      })
    },
    toJump (text, path, id, idList) {
      idList = idList ? idList : []
      if (id == 174) {
        let { isVuePage } = this.$store.state.power
        if (isVuePage == 'Y') return this.$message.warning('流程已升级，不支持跳转！')
      }
      this.$emit('toJumps', { text, path, id, idList })
      // top.addPanelwithTab(text, path)
    }
  }
}
</script>

<style lang="less" scoped>
.carpin {
  height: calc(100% - 15px);
  overflow: auto;
  margin-top: 15px;
  .title {
    text-align: center;
    color: #2c67ff;
    font-size: 1.2vw;
  }
  .el-row {
    display: flex;
    align-items: center;
    .el-col {
      .grid-content {
        box-shadow: 0px 0px 15px 0px 
        rgba(72, 0, 255, 0.2);
        border-radius: 16px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: space-around;
        position: relative;
        max-width: 266px;
        cursor: pointer;
        color: #fff;
        margin: 0 auto;
        &:not(:nth-child(1)) {
          margin-top: 24px;
        }
        img {
          width: 40%;
        }
      }
    }
    .child {
      .el-row {
        &:nth-child(2) {
          margin-top: 24px;
        }
      }
    }
    .divider {
      display: flex;
      flex-flow: column;
      align-items: flex-end;
      ::v-deep .el-divider {
        margin: 0;
        height: 4px;
        background-color: #a5beff;
      }
      .el-divider--vertical {
        height: 8vw;
        width: 4px;
      }
      .vertical {
        height: 12vw;
      }
      .vertical_one {
        height: 11vw;
        transform: translate(0, 50%);
      }
      .vertical_two {
        height: 12.3vw;
        transform: translate(0, -2.02vw);
      }
    }
  }
}
</style>